var _defs, _g, _polygon, _polygon2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIconsMousewheelUpDown(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #202346;\n        stroke-width: .75px;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-3 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #d3343f;\n      }\n\n      .cls-2, .cls-4 {\n        fill: #d3343f;\n      }\n\n      .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        stroke: #fff;\n        stroke-width: .5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.19,31.46c0,5.32,4.39,9.64,9.81,9.64s9.81-4.31,9.81-9.64c0,0,0-14.67,0-14.67,0-5.32-4.39-9.64-9.81-9.64s-9.81,4.31-9.81,9.64c0,0,0,14.67,0,14.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m25,18.47c5.42,0,9.81-.75,9.81-1.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.19,16.79c0,.93,4.39,1.68,9.81,1.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m25,21.57c-1.07,0-1.94-.85-1.94-1.9v-5.34c0-1.05.87-1.9,1.94-1.9s1.94.85,1.94,1.9v5.34c0,1.05-.87,1.9-1.94,1.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23.97,
    y1: 19.94,
    x2: 26.04,
    y2: 19.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23.97,
    y1: 18.47,
    x2: 26.04,
    y2: 18.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23.97,
    y1: 17,
    x2: 26.04,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23.97,
    y1: 15.52,
    x2: 26.04,
    y2: 15.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 23.97,
    y1: 14.05,
    x2: 26.04,
    y2: 14.05
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "21.89 5.39 20.92 4.49 25 0 29.08 4.49 28.11 5.39 25.66 2.67 25.66 10.37 24.34 10.37 24.34 2.67 21.89 5.39"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "28.11 28.89 29.08 29.79 25 34.27 20.92 29.79 21.89 28.89 24.34 31.6 24.34 23.9 25.66 23.9 25.66 31.6 28.11 28.89"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIconsMousewheelUpDown);
export default __webpack_public_path__ + "static/media/help_icons_mousewheel_up_down.17cb2fa79881b2876d56907bf8c975d4.svg";
export { ForwardRef as ReactComponent };